import React, { Component, PropTypes } from 'react';
import ToolbarItem from '../../ui/sabre-spark-react-ex/toolbar/toolbar-item';
import Toolbar from '../../ui/sabre-spark-react-ex/toolbar/toolbar';
import withTooltip from '../../ui/sabre-spark-react-ex/tooltip';

class FileName extends Component {
    static defaultProps = {
        tooltipPosition: 'right'
    };
    render() {
        return (
            <div className="custom-content__filename__file">
                <span>{this.props.file instanceof Object ? '' : this.props.file}</span>
                <span className={'spark-tooltip__content--' + this.props.tooltipPosition} role="tooltip">
                    {this.props.file instanceof Object ? '' : this.props.file}
                    <span className="spark-tooltip__caret"></span>
                </span>
            </div>
        );
    }
}

const FileNameWithTooltip = withTooltip(undefined, 'bottom')(FileName);

export const CodeEditorPanelSectionToolbar = props => {
    const { permission } = props;
    const toolbar0 = props.file ? (
        <Toolbar tabIndex="0" role="menubar" className="spark-toolbar--icon">
            <ToolbarItem
                disabled={!permission.edit}
                role="menuitem"
                tabIndex="-1"
                label="Select a file"
                skipContentContainer={true}
                iconClass="spark-icon-link"
                onClick={props.onSelect}
            />
        </Toolbar>
    ) : null;

    const toolbar1 = (
        <Toolbar tabIndex="0" role="menubar" className="spark-toolbar--icon">
            {props.file ? (
                <ToolbarItem
                    disabled={!permission.edit}
                    role="menuitem"
                    tabIndex="-2"
                    label="Clear"
                    skipContentContainer={true}
                    iconClass="spark-icon-trash"
                    onClick={() => {
                        if (permission.edit) {
                            props.onClear();
                        }
                    }}
                />
            ) : (
                <ToolbarItem
                    disabled={!permission.edit}
                    role="menuitem"
                    tabIndex="-1"
                    label="Select a file"
                    skipContentContainer={true}
                    iconClass="spark-icon-link"
                    onClick={() => {
                        if (permission.edit) {
                            props.onSelect();
                        }
                    }}
                />
            )}
            <ToolbarItem
                disabled={props.loading ? props.loading : false}
                role="menuitem"
                tabIndex="-2"
                label="Edit"
                skipContentContainer={true}
                iconClass={permission.edit ? `spark-icon-pencil` : 'spark-icon-password-view'}
                onClick={() => {
                    props.onEdit();
                }}
            />
        </Toolbar>
    );
    const FileNameComponent = props.file instanceof Object || !props.file ? FileName : FileNameWithTooltip;

    return (
        <div>
            <div className="row spark-bold">
                <div className="col-xs">{props.label}</div>
            </div>
            <div className="row">
                <div className="col-xs bed-nowrap spark-flex spark-align-items-center">
                    <div>{props.renderButtons && toolbar0}</div>
                    <div className="custom-content__filename">
                        <FileNameComponent tooltipText={props.file} tooltipPosition={'bottom'} file={props.file} />
                    </div>
                    <div className="spark-mar-l-1 spark-mar-r-1">{props.renderButtons && toolbar1}</div>
                </div>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/widgets/CodeEditor/CodeEditorPanelSectionToolbar.js